"use strict";
exports.__esModule = true;
exports.ExtraService = void 0;
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var store_1 = require("./store");
var extra_helper_service_1 = require("./extra-helper.service");
var getExtra = function (sessionId) {
    store_1.ExtraStore.setLoading(true);
    return extra_helper_service_1.ExtraHelperService.fetchExtra(sessionId).pipe(operators_1.first(), operators_1.map(function (extras) {
        store_1.ExtraStore.update(extras);
        store_1.ExtraStore.setLoading(false);
        return extras;
    }), operators_1.catchError(function (err) {
        store_1.ExtraStore.setLoading(false);
        return rxjs_1.of({ hotelExtras: [], roomExtras: {} });
    }));
};
var resetCacheFetchExtra = function () { return extra_helper_service_1.ExtraHelperService.resetCacheFetchExtra(); };
exports.ExtraService = { getExtra: getExtra, resetCacheFetchExtra: resetCacheFetchExtra };
//# sourceMappingURL=extra.service.js.map